export default __webpack_public_path__ + "056bd5cdf680a5bd9d7548d3bfc8a0d5.png";